import { tap } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { State, Selector, Action, StateContext } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { IOrgUnit } from '../../interfaces/orgunit/IOrgUnit';
import { OrgUnitService } from '../../services/orgUnit.service';
import { CreateOrgUnit, LoadOrgUnits, UpdateOrgUnit } from './orgUnit.actions';

export interface IOrgUnitStateModel {
  orgUnits: IOrgUnit[];
  isLoading: boolean;
}

@State<IOrgUnitStateModel>({
  name: 'orgUnitState',
  defaults: {
    orgUnits: [],
    isLoading: false,
  },
})
@Injectable()
export class OrgUnitState {
  private orgUnitService = inject(OrgUnitService);

  @Selector()
  static orgUnits(state: IOrgUnitStateModel): IOrgUnit[] {
    return state.orgUnits;
  }

  @Selector()
  static isLoading(state: IOrgUnitStateModel): boolean {
    return state.isLoading;
  }

  @Action(LoadOrgUnits)
  loadOrgUnits(ctx: StateContext<IOrgUnitStateModel>): Observable<IOrgUnit[]> {
    this.setIsLoading(ctx, true);
    return this.orgUnitService.getOrgUnits().pipe(
      tap(result => {
        ctx.setState(
          patch<IOrgUnitStateModel>({
            orgUnits: result,
          }),
        );
      }),
      finalize(() => this.setIsLoading(ctx, false)),
    );
  }

  @Action(UpdateOrgUnit)
  updateOrgUnit(ctx: StateContext<IOrgUnitStateModel>, payload: UpdateOrgUnit): Observable<void | HttpErrorResponse> {
    this.setIsLoading(ctx, true);
    return this.orgUnitService.updateOrgUnit(payload.orgUnit).pipe(finalize(() => this.setIsLoading(ctx, false)));
  }

  @Action(CreateOrgUnit)
  createOrgUnit(ctx: StateContext<IOrgUnitStateModel>, payload: CreateOrgUnit): Observable<void | HttpErrorResponse> {
    this.setIsLoading(ctx, true);
    return this.orgUnitService.createOrgUnit(payload.orgUnit).pipe(finalize(() => this.setIsLoading(ctx, false)));
  }

  private setIsLoading(ctx: StateContext<IOrgUnitStateModel>, isLoading: boolean): void {
    ctx.setState(patch<IOrgUnitStateModel>({ isLoading }));
  }
}
